<template>
  <div id="addCaseWorker">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="addCaseWorker">
      <v-container>
        <!-- <v-card flat class="pf-width-100p"> -->
          <v-card-text class="px-3">
        <h5>Please Fill The Below Fileds  to Add a Caseworker</h5>
        <v-layout wrap center class="pb-4 pt-3">
          <v-flex>
            <v-layout wrap >
              <v-flex xs12 sm4>
                <v-text-field label="Firstname" v-model.trim="newCaseWorker.first_name" class="requiåred pr-4 pl-4"
                  :rules="[rules.required]" @input="changedData">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field label="Lastname" v-model.trim="newCaseWorker.last_name" class="pr-4 pl-4"
                   @input="changedData"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field label="Username" v-model.trim="newCaseWorker.username" class="required pr-4 pl-4" browser-autocomplete="new-username"
                  :rules="[rules.required]" @input="changedData" @change="duplicateUserNameChecking" :success-messages="this.usernameFlag ? 'username is available': ''"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field label="Password" browser-autocomplete="new-password" :append-icon="showPassword ? 'visibility' : 'visibility_off'" @click:append="showPassword = !showPassword" :type="showPassword ? 'text' : 'password'" v-model.trim="newCaseWorker.password" class="pl-4" @input="changedData"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field label="Email Address" v-model.trim="newCaseWorker.email" :rules="[rules.required, rules.emailRules ]"
                  class="required pr-4 pl-4" @input="changedData" @change="duplicateEmailChecking"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field label="Phone" v-mask="'(###) ###-####'" placeholder="(###) ###-####" v-model.trim="newCaseWorker.phone" :rules="[rules.phoneRules]"
                  class="pr-4 pl-4" @input="changedData"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field label="Website" v-model.trim="newCaseWorker.website" :rules="rules.websiteRules"
                  class="pr-4 pl-4" @input="changedData"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" to="/countries" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        </v-card-text>
        <!-- </v-card> -->
      </v-container>
    </v-form>
  </div>
</template>
  
<script>
/* global session router store config */
import { getCollection, request, validateUrl, checkIfNoPFUrl, guestLogin, isEmailValid } from '../../../helpers/helpers';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import { mask } from 'vue-the-mask';

// To add new countries by the admin
export default {
  name: 'AddCaseWorker',
  directives: { mask },
  data: () => ({
    newCaseWorker: {
      first_name: '',
      last_name: '',
      email: '',
      username: '',
      password: '',
      phone: '',
      website: ''
    },
    config: config,
    rules: {
      required: value => !!value || 'Field is required.',
      blankRules: (v) => !!v && v.trim().length > 0 || 'Field is required',
      emailRules: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(v) || 'Please enter valid email address',
      zipRules: (v) => v === undefined || v === '' || /^([0-9]{5}|[0-9]{6})(?:-[0-9]{4})?$/.test(v) || 'Please enter valid zip code',
      phoneRules: (v) => v === undefined || v === '' || /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number',
      websiteRules: [
        (v) => v === undefined || v === '' || (validateUrl(v)) || 'Please enter valid URL',
        v => !v || checkIfNoPFUrl(v) || 'The entered URL is not valid for campaigns'
      ]
    },
    loading: false,
    selectedData: false,
    usernameFlag: false,
    emailFlag: false,
    showPassword: false
  }),
  computed: {
    ...mapGetters(['Agency']),
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
  },
  methods: {
    changedData () {
      this.selectedData = true;
    },
  
    hideButtons () {
      this.selectedData = false;
    },
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.$router.push({ path: '/agency/account' });
    },
    async duplicateEmailChecking () {
      if (this.newCaseWorker.email && isEmailValid(this.newCaseWorker.email)) {
        const emailUrl = `User/EmailCheck/${this.newCaseWorker.email}`;
        let { error, data } = await request(emailUrl, 'GET', {}, null, null);
        if (error === 'Email address exists') {
          console.log(error);
          swal.fire({
            title: 'The email already exists',
            type: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Close',
            allowOutsideClick: false    
          }).then((result) => {
            this.newCaseWorker.email = '';
          });
        } else {
          this.emailFlag = true;
        }
      }
    },
    async duplicateUserNameChecking () {
      if (this.newCaseWorker.username && this.newCaseWorker.username.length) {
        const usernameUrl = `User/UsernameCheck/${this.newCaseWorker.username}`;
        const response = await request(usernameUrl, 'GET', {}, null, null);
        if (response.error === 'Username exists') {
          console.log(response.error);
          swal.fire({
            title: 'The username already exists',
            type: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Close',
            allowOutsideClick: false
          }).then((result) => {
            this.newCaseWorker.username = '';
          });
        } else {
          this.usernameFlag = true;
        }
      }
    },
    async save () {
      if (this.$refs.addCaseWorker.validate()) {
        this.hideButtons();
        let name = this.newCaseWorker.first_name + ' ' + this.newCaseWorker.last_name;
        let payload = this.newCaseWorker;
        payload.name = name;
        payload.agency = this.Agency.id;
        let response = await request('Caseworker/Register', 'POST', payload);
        if (response.error) {
          swal.fire({
            type: 'warning',
            title: '<b>Error</b>',
            html: response.message,
            showConfirmButton: false,
            timer: 2500
          });
        } else {
          swal.fire({
            type: 'success',
            title: '<b>Success</b>',
            html: response.message,
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/agency/account' });
            }
          });
        }

      }
 
    }   
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Agencies/CaseWorker/addCaseworker.vue